import { ModelViewersKeyType } from '../../keys';

const modelViewersKeys: ModelViewersKeyType = {
  singular: 'Model viewer',
  disableNeutralMaterials: 'Disable neutral materials',
  enableNeutralMaterials: 'Enable neutral materials',
  showHelpers: 'Show helpers',
  hideHelpers: 'Hide helpers',
  meshEdgesNone: 'Disable mesh edges',
  meshEdgesEdges: 'Show mesh edges',
  meshEdgesWireframe: 'Show wireframe',
  screenshot: 'Take screenshot',
  threeDModelViewer: '3D model viewer',
  addReference: 'Add references',
  removeReference: 'Remove reference',
  createLifestyle: 'Create lifestyle',
  createSilo: 'Create silo',
  createCloseUp: 'Create close up',
  lifestyleSceneDescription: 'Generate lifestyle scene with AI',
  siloSceneDescription: 'Enhance materials of a model on a white background',
  closeUpSceneDescription: 'Generate a close-up view of the model',
  generationModeLabel: 'mode:',
  generationModeLifestyle: 'lifestyle',
  generationModeSilo: 'silo',
  generationModeSiloRender: 'silo render',
  generationModeCloseUp: 'close up',
  generationModeEdit: 'edit',
  generatingLifestyle: 'Generating...',
  createdLifestyles: 'Created lifestyles',
  generationFailed: 'Generation failed',
  generatedLifestyle: 'Generated lifestyle',
  lifestylePromptPlaceholder: 'Set angle and describe the lifestyle scene...',
  backToModel: 'Back to model',
  backgroundDefault: 'Default',
  backgroundBlack: 'Black',
  backgroundWhite: 'White',
  backgroundGray: 'Gray',
  backgroundCustom: 'Custom color',
  backgroundImage: 'Image background',
  backgroundColorPicker: 'Color picker',
  backgroundImageModalTitle: 'Image background',
  aiImageryTool: 'AI Imagery Tool',
  openConfigurator: 'Open configurator',
  configuratorExportFailed: 'Failed to export model from configurator',
  commands: 'Commands',
  removeCommand: 'Remove command',
  quickLifestyle: 'Quick Create',
  displaySettings: 'Display settings',
  aspectRatio: 'Aspect ratio',
  aspectRatioAuto: 'Auto',
  aspectRatioSquare: 'Square',
  aspectRatioLandscape: 'Landscape',
  aspectRatioPortrait: 'Portrait',
  aspectRatioShowGridLines: 'Show grid lines',
  resolution: 'Resolution',
  unitsMetric: 'Metric (cm)',
  unitsImperial: 'Imperial (in)',
  meshDisplay: 'Mesh display',
  meshDisplayNormal: 'Normal',
  toolHand: 'Hand',
  toolMeasure: 'Measurement',
  requestRender: 'Request render',
  studioRender: 'Studio Render',
  renderingImage: 'Rendering image',
  renderingImageDescription1:
    'Your model was sent to the rendering server at the exact view angle you set, framed to the aspect ratio chosen in <accent>Display settings</accent>.',
  renderingImageDescription2:
    'It’s now being rendered with high-quality materials and studio lighting — this takes about 1 minute on average.',
  renderingImageDescription3:
    'Please keep this window open until the render is complete.',
  renderRequested: 'Render request added to the queue',
  renderRequestFailed: 'Failed to request render',
  generationModeProductLifestyle: 'product lifestyle',
  createProductLifestyle: 'Create lifestyle from 3D studio render',
  createProductLifestyleShort: 'Create studio lifestyle',
  closeWithoutSavingTitle: 'Close without saving?',
  closeWithoutSavingDescription:
    'Your generated images won’t be saved. Download the ones you want to keep before closing — otherwise they’ll be lost.',
  closeAnyway: 'Close anyway'
};

export default modelViewersKeys;
